<ng-order-fill
  *ngIf="(store$ | async) as store"
  [loading]="store.state.loading"
  [loadingFilters]="store.loadingLocations || store.loadingPatterns"
  [requested]="store.state.requested"
  [accepted]="store.state.accepted"
  [acceptedNotFilled]="store.state.acceptedNotFilled"
  [notAccepted]="store.state.notAccepted"
  [dateInterval]="store.dateInterval"
  [filled]="store.state.filled"
  [metrics]="store.state.metrics"
  [doofFeature]="(doofFeature | async)!"
  (selectedOrderFill)="loadSummary($event)"
></ng-order-fill>
